<template>
  <div class="goods meeting">
    <v-head :title="title"></v-head>
    <div class="voteBox">
      <!-- <p v-if="list.content && !list.content.length">没有数据了～</p> -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul>
          <li
            v-for="(item, index) in list.content"
            :key="index"
            @click="goDetail(item)"
          >
            <h4>{{ item.name }}</h4>
            <div style="margin-top:10px">
              <van-tag type="primary" v-if="item.visibleRange == 1"
                >所有人</van-tag
              >
              <van-tag type="danger" v-else>指定人</van-tag>
            </div>
            <p>
              {{ item.content }}
            </p>
            <div>
              <b>已参与人数：{{ item.visitors ? item.visitors : 0 }}人</b>
              <b
                >投票时间：{{ item.startTime | limitDate }} -
                {{ item.endTime | limitDate }}</b
              >
            </div>
          </li>
        </ul>
      </van-list>
    </div>

    <vNavbar :active="navActive" @on_chang_active="changActive"></vNavbar>
  </div>
</template>

<script>
import vHead from "../../components/header.vue";
import vNavbar from "../../components/navbar.vue";
import {
  Tag,
  Toast,
  Button,
  Tabs,
  Loading,
  Divider,
  List,
  Cell,
} from "vant";
import { mapGetters, mapState, mapActions } from "vuex";
import {
  getUser,
  getElectionReleasePage,
} from "@/api/dictionary";
import { getSessionStore } from "@/utils/sessionStorage.js";
export default {
  data() {
    return {
      navActive: 3,
      page: -1,
      title: "投票",
      loading: false,
      finished: false,
      list: [],
      vote: {
        name: "",
        mobile: "",
      },
    };
  },
  components: {
    vHead,
    vNavbar,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    [Divider.name]: Divider,
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
  },
  methods: {
    ...mapActions(["getGroupMemberType", "getPersonMemberType"]),
    goPath(pathName) {
      this.$router.push({ name: pathName });
    },
    changActive(val) {
      this.navActive = val;
    },
    goDetail(item) {
      this.$router.push({name: "voteDetails", query: { id: item.id }});
    },
    onLoad() {
      // 异步更新数据
      let params = {};
      this.page = this.page + 1;
      params.visibleRangeList = 1;
      getElectionReleasePage(params, this.page).then((res) => {
        if (res.success) {
          this.list = res.result;
          this.loading = false;

          if (this.list.content.length >= res.result.totalElements) {
            this.finished = true;
          }
        }
      });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.meeting /deep/.van-nav-bar__title,
.meeting /deep/.van-nav-bar__text {
  color: #000 !important;
}
.meeting /deep/.sign_out {
  color: #000 !important;
}
.voteBox {
  background: #fafafa;
  padding: 20px 4%;
  margin-top: 55px;
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  width: 92%;
  margin-bottom: 40px;
}
.voteBox ul {
  margin-bottom: 86px;
}
.voteBox ul li {
  border: #ddd solid 1px;
  border-radius: 5px;
  padding: 15px;
  background: #fff;
  margin-bottom: 15px;
}
.voteBox ul li h4 {
  color: #000;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.voteBox ul li p {
  font-size: 14px;
  text-overflow: -o-ellipsis-lastline;
  margin: 10px 0;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.voteBox ul li > div {
  font-size: 12px;
}
.voteBox ul li > div b {
  margin-right: 10px;
}
/deep/.van-dialog__content {
  padding: 15px 15px;
}
/deep/.van-field__label {
  width: 4.2em;
}
</style>
